import { getStoredUser } from '../helpers/storage';

const attached = new WeakSet();

/**
 * Attach auth + 401 handling to an axios instance (default axios and http-common share the same rules).
 * @param {import('axios').AxiosInstance} client
 * @param {() => void} onUnauthorized
 */
export function attachAuthInterceptors(client, onUnauthorized) {
    if (!client || attached.has(client)) return;
    attached.add(client);

    client.interceptors.request.use(
        (config) => {
            const user = getStoredUser();
            if (user?.accessToken) {
                config.headers.Authorization = `Bearer ${user.accessToken}`;
                config.headers['x-access-token'] = user.accessToken;
            }
            return config;
        },
        (error) => Promise.reject(error),
    );

    client.interceptors.response.use(
        (response) => response,
        (error) => {
            if (error.response?.status === 401) {
                onUnauthorized();
            }
            return Promise.reject(error);
        },
    );
}
